import ClassicBridge from '../next/ClassicBridge'

export default function sendUserEvent(event, params) {
    // just an alias to reduce amount of changes
    ClassicBridge.sendUserEvent(event, params, true)
}


// WEBPACK FOOTER //
// ./web/js/userEvents/sendUserEvent.js